module.exports = __webpack_public_path__ + "img/platform_circle.55631f30.png";